declare global {
  interface Window {
    __APP_CONFIG__?: {
      apiBaseUrl?: string;
      registryStrictUrl?: string;
      registryLenientUrl?: string;
      registryMalwareUrl?: string;
    };
  }
}

function valueOr<T>(v: T | undefined | null, fallback: T): T {
  return v ?? fallback;
}

export function getApiBaseUrl(fallback: string): string {
  return valueOr(window.__APP_CONFIG__?.apiBaseUrl, fallback);
}

export function getRegistryStrictUrl(fallback: string): string {
  return valueOr(window.__APP_CONFIG__?.registryStrictUrl, fallback);
}

export function getRegistryLenientUrl(fallback: string): string {
  return valueOr(window.__APP_CONFIG__?.registryLenientUrl, fallback);
}

export function getRegistryMalwareUrl(fallback: string): string {
  return valueOr(window.__APP_CONFIG__?.registryMalwareUrl, fallback);
}

export {};
